/**
 * @file CurrentIdentityWidget.tsx
 * @description Виджет «кто я и где я» в шапке (phase08.5 shadcn).
 */

import { formatContextLabel } from "../auth/format";
import type { AccountContext, UserSummary } from "../auth/types";

interface Props {
  user: UserSummary;
  activeContext: AccountContext | null;
}

export function CurrentIdentityWidget({ user, activeContext }: Props) {
  const label = formatContextLabel(activeContext);
  return (
    <div
      className="flex flex-col items-end gap-0.5 leading-tight"
      data-testid="identity-widget"
    >
      <span
        className="text-sm font-medium text-on-surface truncate max-w-[200px]"
        data-testid="identity-email"
      >
        {user.displayName ?? user.email}
      </span>
      <span
        className="text-xs text-on-surface-variant truncate max-w-[200px]"
        data-testid="identity-context"
      >
        {label}
      </span>
    </div>
  );
}
